import React from 'react'

import { useColorableSpaceStyle } from '../../utils/styles/colorableSpace'
import Button from './Button'
import IconText from '../presentation/IconText'

const IconButton = ({ onClick, ...props }) => {
  const [, fontColor] = useColorableSpaceStyle({ ...props })

  return (
    <Button onClick={onClick} {...props}>
      <IconText {...props} color={fontColor} />
    </Button>
  )
}

export default IconButton
